<template>
    <section>
        <app-header-bar/>

        <!-- As soon as this element scrolls out of the viewport, consider page "scrolled": -->
        <app-scroll-detector/>

        <main class="content">
            <router-view/>
        </main>

        <!-- On desktop the settings hang from the gear in the header (see AppHeaderBar). -->
        <app-menu
            v-if="isMobile"
            v-bind:isOpen.sync="settingsModalVisible"
        />

        <app-toast-container/>
        <app-up-button/>
    </section>
</template>

<script>
import { computed } from 'vue';
import AppScrollDetector from '~/components/AppScrollDetector.vue';
import AppToastContainer from '~/components/AppToastContainer.vue';
import AppHeaderBar from '~/components/AppHeaderBar.vue';
import AppUpButton from '~/components/AppUpButton.vue';
import { APP_MAIN_LOCALE } from '~/config';
import { SUPPORTED_LOCALES } from '~/i18n';
import AppMenu from './menu/AppMenu.vue';

export default {
    data() {
        return {
            settingsModalVisible: false,
            mtwSource: false,
        };
    },

    mounted() {
        // Has property ?source=mtw in URL
        if (this.$route.query.source === 'mtw') {
            this.mtwSource = true;
            this.$router.replace({ query: undefined });
        }
        // Hash ends with ?source=mtw
        if (this.$route.hash && this.$route.hash.endsWith('?source=mtw')) {
            this.mtwSource = true;
            this.$router.replace({ hash: this.$route.hash.replace('?source=mtw', '') });
        }
    },

    provide() {
        return {
            closeSettings: () => {
                this.settingsModalVisible = false;
            },
            toggleSettings: () => {
                this.settingsModalVisible = !this.settingsModalVisible;
            },
            isSettingsOpened: computed(() => this.settingsModalVisible),
        };
    },

    metaInfo() {
        return {
            // Pages override this via the same vmid; the static tag in index.ejs
            // carries data-vmid so vue-meta replaces it instead of adding a second one:
            meta: [{
                vmid: 'description',
                name: 'description',
                content: this.$t('indexpage.meta.description'),
            }],

            // Add alternate lang links and canonical to every page:
            // @see https://developers.google.com/search/docs/specialty/international/localized-versions
            link: [
                ...SUPPORTED_LOCALES.map(lang => Object.freeze({
                    rel: 'alternate',
                    hreflang: lang,
                    href: this.$localizedUrl(lang),
                })),
                {
                    rel: 'alternate',
                    hreflang: 'x-default',
                    href: this.$localizedUrl(APP_MAIN_LOCALE),
                },
                { rel: 'canonical', href: `${document.location.origin}${this.$route.path}` },
            ],
        };
    },

    components: {
        AppScrollDetector,
        AppToastContainer,
        AppHeaderBar,
        AppUpButton,
        AppMenu,
    },
};
</script>
